import { EThemeType } from '@/hooks/useTheme';

const PREFIX = 'anc';

export enum ELocalStorageKey {
  SESSION_ID = `${PREFIX}_sessionId`,
  THEME = `${PREFIX}_theme`,
}

export const getTheme = () => {
  if (typeof localStorage !== 'undefined') {
    const storedTheme = localStorage.getItem(ELocalStorageKey.THEME);
    return storedTheme;
  }
};

export const setTheme = (data: EThemeType) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(ELocalStorageKey.THEME, data);
  }
};

export const getSessionIdForCart = () => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(ELocalStorageKey.SESSION_ID);
  }
  return null;
};

export const setSessionIdForCart = (sessionId: string) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(ELocalStorageKey.SESSION_ID, sessionId);
  }
};
